/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerFeeTypeResource } from './';
import {
    FreelancerFeeTypeResourceFromJSON,
    FreelancerFeeTypeResourceFromJSONTyped,
    FreelancerFeeTypeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerFeeResource
 */
export interface FreelancerFeeResource {
    /**
     * 
     * @type {Date}
     * @memberof FreelancerFeeResource
     */
    startDate: Date;
    /**
     * this fees rate is application for X months
     * @type {number}
     * @memberof FreelancerFeeResource
     */
    numberOfMonth: number;
    /**
     * 
     * @type {FreelancerFeeTypeResource}
     * @memberof FreelancerFeeResource
     */
    type: FreelancerFeeTypeResource;
    /**
     * 
     * @type {number}
     * @memberof FreelancerFeeResource
     */
    percent: number;
}

/**
 * Check if a given object implements the FreelancerFeeResource interface.
 */
export function instanceOfFreelancerFeeResource(value: object): value is FreelancerFeeResource {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('numberOfMonth' in value) || value['numberOfMonth'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('percent' in value) || value['percent'] === undefined) return false;
    return true;
}

export function FreelancerFeeResourceFromJSON(json: any): FreelancerFeeResource {
    return FreelancerFeeResourceFromJSONTyped(json, false);
}

export function FreelancerFeeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerFeeResource {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': (new Date(json['startDate'])),
        'numberOfMonth': json['numberOfMonth'],
        'type': FreelancerFeeTypeResourceFromJSON(json['type']),
        'percent': json['percent'],
    };
}

export function FreelancerFeeResourceToJSON(value?: FreelancerFeeResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'numberOfMonth': value['numberOfMonth'],
        'type': FreelancerFeeTypeResourceToJSON(value['type']),
        'percent': value['percent'],
    };
}

